<svg
  [attr.width]="width"
  [attr.height]="height"
  fill="none"
  viewBox="0 0 14 14"
  xmlns="http://www.w3.org/2000/svg"
  [style.opacity]="opacity"
  class="block shrink-0"
>
  @if (hasGradient) {
    <defs>
      <linearGradient
        [attr.id]="gradientId"
        x1="14"
        y1="0"
        x2="0.366272"
        y2="14.3481"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0%" [style.stop-color]="startColor" />
        <stop offset="100%" [style.stop-color]="endColor" />
      </linearGradient>
    </defs>
  }

  <path
    d="M0 1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0H13C13.2652 0 13.5196 0.105357 13.7071 0.292893C13.8946 0.48043 14 0.734784 14 1V3C14 3.26522 13.8946 3.51957 13.7071 3.70711C13.5196 3.89464 13.2652 4 13 4H1C0.734784 4 0.48043 3.89464 0.292893 3.70711C0.105357 3.51957 0 3.26522 0 3V1ZM0 7C0 6.73478 0.105357 6.48043 0.292893 6.29289C0.48043 6.10536 0.734784 6 1 6H7C7.26522 6 7.51957 6.10536 7.70711 6.29289C7.89464 6.48043 8 6.73478 8 7V13C8 13.2652 7.89464 13.5196 7.70711 13.7071C7.51957 13.8946 7.26522 14 7 14H1C0.734784 14 0.48043 13.8946 0.292893 13.7071C0.105357 13.5196 0 13.2652 0 13V7ZM11 6C10.7348 6 10.4804 6.10536 10.2929 6.29289C10.1054 6.48043 10 6.73478 10 7V13C10 13.2652 10.1054 13.5196 10.2929 13.7071C10.4804 13.8946 10.7348 14 11 14H13C13.2652 14 13.5196 13.8946 13.7071 13.7071C13.8946 13.5196 14 13.2652 14 13V7C14 6.73478 13.8946 6.48043 13.7071 6.29289C13.5196 6.10536 13.2652 6 13 6H11Z"
    [attr.fill]="hasGradient ? 'url(#' + gradientId + ')' : defaultColor"
  />
</svg>
